enum QBDSkuPropertyEnum {
    Name = "Name",
    FullName = "FullName",
    ManufacturerPartNumber = "ManufacturerPartNumber",
    Description = "Description",
}

export default QBDSkuPropertyEnum;
